import BankistImg from "../../../assets/images/bankist.png";
import FrontendcaseImg from "../../../assets/images/frontendcase.png";
import ShopsPrint from "../../../assets/images/shopsprint.png";
import TalentPortal from "../../../assets/images/talentportal.png";
import MonoText from "../../../assets/images/monotext.png";
import StepsMaster from "../../../assets/images/stepsmaster.png";

export const ProjectTitleData = [
  {
    title: "Crafting Digital Experiences That Matter",
  },
  {
    title: "Mohammed Ameen's Web Development Portfolio",
  },
];

export const projectsData = [
  {
    title: "Bankist",
    type: "Frontend Development",
    description:
      "Bankist-Complete is a sleek website built with HTML, SCSS, and JavaScript. Easily create, log in, delete accounts, transfer money to predefined users, and make money requests. Experience automatic logout for added security when 10 min countdown finishes . Explore the live demo for a hands-on preview.",
    technologies: ["html", "css", "scss", "js"],
    img: BankistImg,
    url: "https://github.com/Ameer2000Mzori/Bankist-Complete",
  },
  {
    title: "Shop Sprint",
    type: "Full-Stack Development",
    description:
      "ShopSprint is one of the major websites I've developed using the MERN stack, incorporating the latest packages and technologies. Feel free to explore and download the project to see it in action.",
    technologies: ["react.js", "node.js", "mongodb", "express.js"],
    img: ShopsPrint,
    url: "https://github.com/Ameer2000Mzori/ShopSprint",
  },
  {
    title: "frontend case",
    type: "Full-Stack Development",
    description:
      "The company 2DIGITS would like a new website where their customers can see their latest blog posts. To this end, Social Brothers created a design to match the client's requirements.",
    technologies: ["next.js", "tailwind.css", "graphql", "prepr"],
    img: FrontendcaseImg,
    url: "https://github.com/Ameer2000Mzori/frontend-case",
  },
  {
    title: "Talent Portal",
    type: "Frontend Development",
    description:
      "TalentPortal is a website created with Next.js 14, styled with Tailwind CSS, and developed using TypeScript. It utilizes JSON Server for data management. This project serves as a showcase for a job interview.",
    technologies: ["next.js", "Typescript", "tailwind.css"],
    img: TalentPortal,
    url: "https://github.com/Ameer2000Mzori/TalentPortal",
  },
  {
    title: "Mono Text",
    type: "Full-Stack Development",
    description:
      "MonoText-MERN is a website built using the MERN stack, which incorporates React for the front end and Node.js, Express, and MongoDB for the back end. It also utilizes ESLint to ensure cleaner code, Prettier for code formatting, and Tailwind CSS for styling. Please download the project to experience a live demo.",
    technologies: [
      "react.js",
      "javascript",
      "node.js",
      "mongodb.js",
      "express.js",
    ],
    img: MonoText,
    url: "https://github.com/Ameer2000Mzori/MonoText-Mern",
  },
  {
    title: "Steps Master",
    type: "application development",
    description:
      "StepsMaster is an application created with ReactNative with help of (Ionic) and nativewind . It will be available soon on Iphone and Samsung",
    technologies: ["react native", "javascript", "ionic", "nativewind"],
    img: StepsMaster,
    url: "https://github.com/Ameer2000Mzori/StepsMaster",
  },
];
